import type { ResolvedDecision } from "@magnis/client-core";

export function autoApprovalAttemptKey(
  episodeId: string | null,
  toolCallId: string,
): string {
  return `${episodeId ?? "adhoc"}:${toolCallId}`;
}

export function startAllowlistedApproval(
  episodeId: string | null,
  toolCallId: string,
  attempted: Set<string>,
  approve: () => Promise<void>,
): void {
  const attemptKey = autoApprovalAttemptKey(episodeId, toolCallId);
  attempted.add(attemptKey);
  void approve().catch(() => {
    attempted.delete(attemptKey);
  });
}

export function shouldRenderHistoricalAllowlistCard(
  decision: ResolvedDecision | null,
  toolCallStatus: "pending" | "approved" | "denied",
  hasMatchingGrant: boolean,
): boolean {
  return (
    decision?.kind === "approval" &&
    decision.status === "approved" &&
    toolCallStatus === "approved" &&
    hasMatchingGrant
  );
}
